import type { ReactNode } from 'react';

interface AuthHeroH1Props {
  children: ReactNode;
}

export function AuthHeroH1({ children }: AuthHeroH1Props) {
  return (
    <h1 className="text-5xl sm:text-7xl md:text-8xl font-extrabold mb-8 tracking-tighter">
      <span
        className="inline-block text-transparent bg-clip-text 
                                        bg-gradient-to-r from-neutral-900 to-neutral-700/80 
                                        dark:from-white dark:to-white/80"
      >
        {children}
      </span>
    </h1>
  );
}
